import parseRoute from '../utils/parseRoute.ts';
import ProductDetailsHero, {
  type ProductDetailsHeroProps
} from './ProductDetailsHero.tsx';
import type { PDPRoute } from '@/domain/Route.ts';
import * as Remote from './Remote.ts';
import HeroLayout from './HeroLayout/HeroLayout.tsx';
import Loader from '../components/containers/Loader/Loader.tsx';
import { pbSelector } from './config/index.ts';

async function load() {
  const route: PDPRoute = parseRoute(
    // eslint-disable-next-line no-underscore-dangle
    window?.__pb__?.user?.productUrl ?? globalThis?.location?.href
  );
  const remoteData = await Remote.getRemoteData(route);

  if (!remoteData.product) {
    throw new Error('Product not found');
  }

  return {
    route,
    ...remoteData
  } as ProductDetailsHeroProps;
}

type ProductDetailsHeroLoaderProps = {
  showSkeleton?: boolean;
};

export default function ProductDetailsHeroLoader({
  showSkeleton = true
}: ProductDetailsHeroLoaderProps) {
  return (
    <Loader<ProductDetailsHeroProps>
      load={load}
      pbSelector={pbSelector}
      showSkeleton={showSkeleton}
      renderSkeleton={() => <HeroLayout.Skeleton />}
    >
      {({ route, product, config, marketConfig, staticContent }) => (
        <ProductDetailsHero
          route={route}
          product={product}
          config={config}
          marketConfig={marketConfig}
          staticContent={staticContent}
        />
      )}
    </Loader>
  );
}
